import { Alert, Flex, View } from "@aws-amplify/ui-react"
import { useContext } from "react"
import ConfigurationContext from "../context/ConfigurationContext.js"
import Translation from "../i18n/Translation.js"
import style from "../style/FaceLivenessDetectorErrorView.module.css"
import type { FaceLivenessDetectionError } from "../support/error/FaceLivenessDetectionError.js"

type Properties = Readonly<{ faceLivenessDetectionError: FaceLivenessDetectionError; source: "amplify" | "manual" }>

export default function FaceLivenessDetectorErrorView({ faceLivenessDetectionError, source }: Properties) {
	const configuration = useContext(ConfigurationContext)
	const alertHeading =
		Translation[configuration.DEFAULT_LOCALE].errorStates?.[faceLivenessDetectionError.state] ||
		Translation[configuration.DEFAULT_LOCALE].errorStates?.UNKNOWN_ERROR
	const alertText =
		Translation[configuration.DEFAULT_LOCALE].errorMessages?.[faceLivenessDetectionError.error.name] ||
		Translation[configuration.DEFAULT_LOCALE].errorMessages?.["default"]
	return (
		<>
			<View className={style[`face-liveness-detector-error-view-${source}`]}>
				<Flex direction="column" className={style[`face-liveness-detector-error-view-flex-${source}`]}>
					<Alert variation="error" isDismissible={false} heading={alertHeading}>
						{alertText}
					</Alert>
				</Flex>
			</View>
		</>
	)
}
